<template>
  <div class="diagram">
    <!-- 1.创建画布 -->
    <div
      :style="{
        height: '100%',
        width: '100%',
        background: '#ffffff',
      }"
      ref="diagram"
      class="scroll"
    ></div>
    <div ref="contextMenu" class="contextMenu" v-show="showContextMenuVisible">
      <div ref="deleteRef" class="contextMenu-item" @click="contextMenuClick('delete')">
        <span>删除</span>
      </div>
      <div ref="copyRef" class="contextMenu-item" @click="contextMenuClick('copy')">
        <span>复制</span>
      </div>
      <div ref="disabledDeleteRef" class="contextMenu-item contextMenu-item-disabled">
        <span>删除</span>
      </div>
      <div ref="disabledCopyRef" class="contextMenu-item contextMenu-item-disabled">
        <span>复制</span>
      </div>
      <div ref="previewRef" class="contextMenu-item" @click="contextMenuClick('preview')">
        <span>预览短信</span>
      </div>
      <div ref="lineRef" class="contextMenu-line"></div>
      <el-popover
        ref="contextMenuPopoverRef"
        placement="right-start"
        width="180"
        trigger="hover"
        popper-class="diagram-contextMenu-popover"
        @show="contextMenuPopoverShow"
      >
        <div :ref="`${item.icon}Ref`" class="contextMenu-item" v-for="item in afterNodeList" :key="item.index" @click="contextMenuClick('afterNodeClick',item)">
          <div class="contextMenu-after">
            <span>{{item.name}}</span>
            <img class="contextMenu-item-img" :src="require('@/assets/imagesZhi/icon/' + item.icon + '.svg')" alt="">
          </div>
        </div>
        <div slot="reference" ref="afterRef" class="contextMenu-item">
          <div class="contextMenu-after">
            <span>插入后置节点</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </el-popover>
    </div>
    <!-- 新加缩略图 -->
    <el-collapse-transition>
      <div v-show="isOverview1" ref="overview" style="background-color:#fff"  class="overview"></div>
    </el-collapse-transition>
    <div ref="overview1" class="overview1">
      <span>缩略图</span>
      <span class="line">|</span>
 
      <el-slider @change = 'sliderChange' v-model="telescoping" class="slider"></el-slider>
      <el-tooltip  effect="dark" content="恢复默认" placement="top">
        <img class="operate-icon reductionIcon" src="../../assets/imagesZhi/Materials/还原.svg" alt="" @click="defaultChange">
      </el-tooltip>
      <el-tooltip  effect="dark" content="全屏" placement="top" v-if="showFull">
        <img class="operate-icon toggleFulls" src="../../assets/imagesZhi/Materials/全屏.svg" alt="" @click="toggleFull">
      </el-tooltip>
      <el-tooltip  effect="dark" content="退出全屏" placement="top" v-else>
        <img class="operate-icon toggleFulls" src="../../assets/imagesZhi/Materials/退出全屏.svg" alt="" @click="toggleFull">
      </el-tooltip>
      <!-- 增加展开收起 -->
      <span style="float: right;cursor: pointer;left: 7px;" > 
        <i v-if="!isOverview1" class="el-icon-arrow-up" @click="expandShrink"></i>
        <i v-if="isOverview1" class="el-icon-arrow-down" @click="expandShrink"></i>
      </span>
    </div>
  </div>
</template>

<script>
import * as go from "gojs";
import { GuidedDraggingTool } from "./GuidedDraggingTool";
import { afterListObj, afterListObjBatch } from "./afterNodeList.js";

export default {
  name: "diagram",
  data() {
    return {
      height: 0,
      width: 0,
      diagram: null,
      overview: null,
      isOverview1: true,
      telescoping: 10,
      showContextMenuVisible:false,
      hoverNode:[],
    };
  },
  props: {
    modelData: {
      type: Object,
    },
    isOverview: {
      type: Boolean,
      default: true,
    },
    app: null,
    edit: {
      type: Boolean,
      default: true,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    icons: {
      type: Array,
      default: () => [],
    },
    showFull:{
      type: Boolean,
      default: true,
    }
  },
  components: {},
  async mounted() {
    // this.buriedPoint(8,'进入智能营销','','','1')
    let isWin = navigator.userAgent.indexOf("Windows") > -1;
    var $this = this;

    //Note----右键菜单

    /*****
     * 步骤2,初始化画布,设置画布,显示栅格*
     ******/
    let mainDiagram = this.$make(this.$go.Diagram, this.$refs.diagram, {
      draggingTool: new GuidedDraggingTool(),
      "draggingTool.horizontalGuidelineColor": "red",
      "draggingTool.verticalGuidelineColor": "red",
      "draggingTool.centerGuidelineColor": "red",
      "draggingTool.guidelineWidth": 1,
      //自动布局设置
      layout: this.$make(go.LayeredDigraphLayout, {
        alignOption: go.LayeredDigraphLayout.AlignAll,   
        layerSpacing: 90,
        isInitial: false,
      }),
      scale: this.telescoping == 10 ? 1 : this.telescoping,
      isReadOnly: $this.isReadOnly || !$this.edit,
      //图的初始内容
      initialContentAlignment: this.$go.Spot.Default,
      //获取或设置选定对象的最大数目，默认值一个正整数
      // maxSelectionCount: 1,
      // 获取或设置用户是否可以调整零件大小
      allowResize: false,
      // 获取或设置用户是否可以旋转零件
      allowRotate: false,
      // 获取或设置用户是否可以进行就地文本编辑
      allowTextEdit: false,
      "undoManager.isEnabled": true,
      scrollMargin: new go.Margin(50, 100, 100, 100),
      //Note--复制粘贴
      "commandHandler.copiesTree": false,
      "dragSelectingTool.delay": 10,
      //Note----多选框选中节点的操作
      "dragSelectingTool.isPartialInclusion": false,

      // 禁止鼠标拖动区域选
      // "dragSelectingTool.isEnabled": false,
      //画布网络
      grid: this.$make(
        this.$go.Panel,
        "Grid",
        { background: "#fafafb" }, // 设置网格背景颜色为灰色
        this.$make(this.$go.Shape, "LineH", {
          stroke: "#E6E7EE",
          strokeWidth: 0.7,
        }),
        this.$make(this.$go.Shape, "LineH", {
          stroke: "#E6E7EE",
          strokeWidth: 0.7,
          interval: 10,
        }),
        this.$make(this.$go.Shape, "LineV", {
          stroke: "#E6E7EE",
          strokeWidth: 0.7,
        }),
        this.$make(this.$go.Shape, "LineV", {
          stroke: "#E6E7EE",
          strokeWidth: 0.7,
          interval: 10,
        }),
        { gridCellSize: new go.Size(15, 15) }
      ),
      //draggingTool为拖拽工具，获取或者设置draggingTool是否将对象捕捉到网格点
      "draggingTool.isGridSnapEnabled": true,
      //获取或者设置调整大小工具是否在调整大小期间将对象大小捕捉到关系图的背景网格
      "resizingTool.isGridSnapEnabled": true,
      "dragSelectingTool.isEnabled": true,
      "linkingTool.portGravity": 80, //加大吸附
      "relinkingTool.portGravity": 80, //加大吸附
      "rotatingTool.handleAngle": 270,
      "rotatingTool.handleDistance": 30,
      "rotatingTool.snapAngleMultiple": 15,
      "rotatingTool.snapAngleEpsilon": 15,
      "toolManager.hoverDelay": 400, //提示显示延时时间
      "animationManager.initialAnimationStyle": this.$go.AnimationManager.None,
      "animationManager.isEnabled": false,
      // "linkingTool.temporaryLink": this.$make(
      //   this.$go.Link,
      //   { layerName: "Tool" },
      //   this.$make(this.$go.Shape, {
      //     stroke: "red",
      //     strokeWidth: 2,
      //     strokeDashArray: [4, 2],
      //   })
      // ),
      "linkingTool.temporaryLink": this.$make(
        this.$go.Link,
        { layerName: "Tool" },
        this.$make(this.$go.Shape, {
          stroke: "#A5AFED",
          fill: "#A5AFED",
        }),
        this.$make(this.$go.Shape, {
          toArrow: "Standard",
          stroke: "#A5AFED",
          fill: "#A5AFED",
        })
      ),
      //连线节点，等待，合并，抽取isValidLink链接是否有效
      //merge是合并节点，await是等待节点，msg是发送短信节点，intersection是交集节点，exclude排除节点，unique排重节点,medium富信节点
      //isValidLink在逻辑上有效的将新链接从一个节点/端口链接到另一个节点端口
      "linkingTool.isValidLink": function (fromnode, fromport, tonode, toport) {
        if ($this.edit) {
          //连线节点，等待，合并，抽取
          //merge是合并节点，await是等待节点，msg是发送短信节点，intersection是交集节点，exclude排除节点，unique排重节点
          //findNodesInto查找节点的上一级节点 findNodesOutOf查找节点的下一级节点
          let relation = {
            await:   {await:1,crowd: 1,vip: 1,senior: 1,order: 1,presell: 1,specific: 1,merge: 1,extraction: 1,intersection: 1,targetGroups: 1,exclude: 1,msg: 1,medium: 1, card: 1,marketing: 1,analyze: 1,customer: 1,unique:1},
            crowd:   {crowd:1,await: 1,vip: 1,senior: 1,order: 1,presell: 1,specific: 1,merge: 1,extraction: 1,intersection: 1,targetGroups: 1,exclude: 1,msg: 1,medium: 1, card: 1,marketing: 1,analyze: 1,customer: 1,unique:1},
            vip:  {vip:1,crowd: 1,await: 1,senior: 1,order: 1,presell: 1,specific: 1,merge: 1,extraction: 1,intersection: 1,targetGroups: 1,exclude: 1,msg: 1,medium: 1, card: 1,marketing: 1,analyze: 1,customer: 1,unique:1},
            senior:  {senior:1,crowd: 1,vip: 1,await: 1,order: 1,presell: 1,specific: 1,merge: 1,extraction: 1,intersection: 1,targetGroups: 1,exclude: 1,msg: 1,medium: 1, card: 1,marketing: 1,analyze: 1,customer: 1,unique:1},
            order: {order:1,crowd: 1,vip: 1,senior: 1,await: 1,presell: 1,specific: 1,merge: 1,extraction: 1,intersection: 1,targetGroups: 1,exclude: 1,msg: 1,medium: 1, card: 1,marketing: 1,analyze: 1,customer: 1,unique:1},
            presell:   {presell:1,crowd: 1,vip: 1,senior: 1,order: 1,await: 1,specific: 1,merge: 1,extraction: 1,intersection: 1,targetGroups: 1,exclude: 1,msg: 1,medium: 1, card: 1,marketing: 1,analyze: 1,customer: 1,unique:1},
            specific:  {specific:1,await: 1,crowd: 1,vip: 1,senior: 1,order: 1,presell: 1,merge: 1,extraction: 1,intersection: 1,targetGroups: 1,exclude: 1,msg: 1,medium: 1, card: 1,marketing: 1,analyze: 1,customer: 1,unique:1},
            merge: {merge:1,await: 1,crowd: 1,vip: 1,senior: 1,order: 1,presell: 1,specific: 1,extraction: 1,intersection: 1,targetGroups: 1,exclude: 1,msg: 1,medium: 1, card: 1,marketing: 1,analyze: 1,customer: 1,unique:1}, //合并链接点判断是否可以链接，新改写法
            extraction: {extraction:1,await: 1,crowd: 1,vip: 1,senior: 1,order: 1,presell: 1,specific: 1,merge: 1,intersection: 1,targetGroups: 1,exclude: 1,msg: 1,medium: 1, card: 1,marketing: 1,analyze: 1,customer: 1,unique:1}, //原来写法，抽取
            intersection:  {intersection:1,await: 1,crowd: 1,vip: 1,senior: 1,order: 1,presell: 1,specific: 1,merge: 1,extraction: 1,targetGroups: 1,exclude: 1,msg: 1,medium: 1, card: 1,marketing: 1,analyze: 1,customer: 1,unique:1},
            targetGroups: {targetGroups:1,await: 1,crowd: 1,vip: 1,senior: 1,order: 1,presell: 1,specific: 1,merge: 1,extraction: 1,intersection: 1,exclude: 1,msg: 1,medium: 1, card: 1,marketing: 1,analyze: 1,customer: 1,unique:1},
            exclude: {exclude:1,await: 1,crowd: 1,vip: 1,senior: 1,order: 1,presell: 1,specific: 1,merge: 1,extraction: 1,intersection: 1,targetGroups: 1,msg: 1,medium: 1, card: 1,marketing: 1,analyze: 1,customer: 1,unique:1},
            unique: {unique:1,await: 1,crowd: 1,vip: 1,senior: 1,order: 1,presell: 1,specific: 1,merge: 1,extraction: 1,intersection: 1,targetGroups: 1,exclude: 1,msg: 1,medium: 1, card: 1,marketing: 1,analyze: 1,customer: 1}, //排重，原来的写法
            msg: {msg:1,await: 1,crowd: 1,vip: 1,senior: 1,order: 1,presell: 1,specific: 1,merge: 1,extraction: 1,intersection: 1,targetGroups: 1,exclude: 1,medium: 1, card: 1,marketing: 1,analyze: 1,customer: 1,unique:1},
            //Note富信与短信相连的是一致的
            medium: {medium:1,await: 1,crowd: 1,vip: 1,senior: 1,order: 1,presell: 1,specific: 1,merge: 1,extraction: 1,intersection: 1,targetGroups: 1,exclude: 1,msg: 1,card: 1,marketing: 1,analyze: 1,customer: 1,unique:1},
            card: {card:1,await: 1,crowd: 1,vip: 1,senior: 1,order: 1,presell: 1,specific: 1,merge: 1,extraction: 1,intersection: 1,targetGroups: 1,exclude: 1,msg: 1,medium: 1,marketing: 1,analyze: 1,customer: 1,unique:1},
            marketing:{marketing:1,await: 1,crowd: 1,vip: 1,senior: 1,order: 1,presell: 1,specific: 1,merge: 1,extraction: 1,intersection: 1,targetGroups: 1,exclude: 1,msg: 1,medium: 1, card: 1,analyze: 1,customer: 1,unique:1},
            analyze: {analyze:1,await: 1,crowd: 1,vip: 1,senior: 1,order: 1,presell: 1,specific: 1,merge: 1,extraction: 1,intersection: 1,targetGroups: 1,exclude: 1,msg: 1,medium: 1, card: 1,marketing: 1,customer: 1,unique:1},
            customer: {customer:1,await: 1,crowd: 1,vip: 1,senior: 1,order: 1,presell: 1,specific: 1,merge: 1,extraction: 1,intersection: 1,targetGroups: 1,exclude: 1,msg: 1,medium: 1, card: 1,marketing: 1,analyze: 1,unique:1},
          };
          console.log(fromnode.data.category);
          // console.log(fromnode, fromport, tonode.findNodesInto(), toport);
          if (
            fromnode.data.category === "await" &&
            tonode.findNodesInto().count === 1
          ) {
            return !1;
          }
          if (
            tonode.data.category === "await" &&
            tonode.findNodesInto().count === 1
          ) {
            return !1;
          }
          if (
            fromnode.data.category === "marketing" &&
            fromnode.findNodesOutOf().count === 1
          ) {
            return !1;
          }
          if (!this.isLinked(fromport, toport)) {
            if (tonode.data.category === "specific") {
              return !1;
            }
          }
          if (
            tonode.data.category === "extraction" &&
            tonode.findNodesInto().count === 1
          ) {
            return !1;
          }
          if (
            tonode.data.category === "unique" &&
            tonode.findNodesInto().count === 1000
          ) {
            return !1;
          }
          if (
            tonode.data.category === "msg" &&
            tonode.findNodesInto().count === 1
          ) {
            return !1;
          }
          if (
            tonode.data.category === "medium" &&
            tonode.findNodesInto().count === 1
          ) {
            return !1;
          }
          if (
            tonode.data.category === "card" &&
            tonode.findNodesInto().count === 1
          ) {
            return !1;
          }
          if (
            tonode.data.category === "marketing" &&
            tonode.findNodesInto().count === 1
          ) {
            return !1;
          }
          if (
            tonode.data.category === "analyze" &&
            tonode.findNodesInto().count === 1
          ) {
            return !1;
          }
          if (
            tonode.data.category === "customer" &&
            tonode.findNodesInto().count === 1
          ) {
            return !1;
          }
          if (
            tonode.data.category === "exclude" &&
            tonode.findNodesInto().count === 20
          ) {
            return !1;
          }
          return (
            relation[fromnode.data.category][tonode.data.category] &&
            !this.isLinked(fromport, toport) &&
            !this.isInSameNode(fromport, toport)
          );
        } else {
          return false;
        }
      },
      // 数据发生变化
      ModelChanged: function (e) {
        $this.$emit("model-changed", e);
      },
      //选择数据发生变化
      ChangedSelection: function (e) {
        $this.$emit("changed-selection", e);
      },
      //双击事件
      // ObjectDoubleClicked: function(e) {
      //   $this.$emit("object-double-clicked", e);
      // },
      //鼠标选择事件
      SelectionMoved: function (e) {
        $this.$emit("select-tion-moved", e);
      },
      SelectionDeleting: function (e) {
        if ($this.edit) {
          //获取第一个选中的节点或者线
          let node = e.diagram.selection.first();
          if (node instanceof $this.$go.Link) {
            let to = node.data.to;
            //限制删除目标人群的链接，gojs模型数据包含两种
            //GraphLinksModel包含nodeDataArray和linkDataArray属性
            //somne依次执行数组的每个元素，item为删除的节点或者线
            // if (
            //   !e.diagram.model.nodeDataArray.some((item) => {
            //     if (
            //       item.smartMarketingNodeId === to &&
            //       item.category === "targetGroups"
            //     ) {
            //       $this.$message.error(
            //         "目标人群链接不允许单独删除！请删除节点"
            //       );
            //       e.cancel = true;
            //       return true;
            //     }
            //   })
            // ) {
            $this.$emit("object-delete", e);
            // }
          } else {
            $this.$emit("object-delete", e);
          }
        } else {
          //非编辑情况下阻止删除
          e.cancel = true;
        }
      },
      //删除对象前
      LinkDrawn: function (e) {
        $this.$emit("LinkDrawn", e);
      },
      //鼠标复制事件
      SelectionCopied: function (e) {
        $this.$emit("select-tion-SelectionCopied", e);
      },
      //e.cancel = true为拦截删除的功能，gojs2.0以后，可能不支持通过另外一种方式实现，
      //重写键盘工具类commandHandler的canDeleteSelection，去拦截调用deleteSelection 实现取消删除的功能
      /**
     * myDiagram.commandHandler.canDeleteSelection = function(e) {
        //用例获取选中的节点或线
        return myDiagram.selection.all(function(nodeOrLink) {
        console.log(nodeOrLink.data);
        //判断是否存在不允许删除的节点或线
        if(nodeOrLink.data.text=="勘察设计"){
          console.log("根存在不允许删除的节点，取消删除");
          return false;
        }else{
          return true;
        }
        });
      ***/
      //Note---粘贴事件
      ClipboardPasted: function (e) {
        $this.$emit("select-tion-SelectionCopied", e);
      },
    });

    //Overview 缩略图
    let myOverview = this.$make(
      go.Overview,
      this.$refs.overview,
      { 
        observed: mainDiagram, 
        contentAlignment: go.Spot.Center,
     
      }
    );
    myOverview.box.elt(0).stroke = "#fe4d45";  // 保持原有边框颜色
    // myOverview.box.elt(0).stroke = "#fe4d45";  //缩略图背景色修改

    // mainDiagram.toolManager.dragSelectingTool.RealtimeDragSelectingTool.doMouseMove();

    // mainDiagram.toolManager.RealtimeDragSelectingTool.insertAt(new doMouseMove());
    //修改布局方式为默认方式
    mainDiagram.layout.isOngoing = false;
    //升级--监听节点是否可以删除,限制删除目标人群的链接,优先判断
    var _this = this;
    mainDiagram.commandHandler.canDeleteSelection = function (e) {
      return mainDiagram.selection.all(function (nodeOrLink) {
        //非编辑状态，测试和正式执行后不可以删除处理
        if(_this.isReadOnly){return false}
        //多节点选的情况
        var nodeOrLinkList = mainDiagram.selection;
        var nodeNumList = [];
        nodeOrLinkList.each((nodeOrLink, index) => {
          nodeNumList.push(nodeOrLink.data);
        });
        let arrParams = [];
        if (nodeNumList.length >= 1) {
          var ipx = 0; //多节点
          nodeNumList.forEach((e) => {
            arrParams.push(e.category);
          });
          const allEqual = arrParams.every((value) => value === "targetGroups");
          if (allEqual == true) {
            $this.$message.error("节点的后置节点不能删除");
            ipx = 1;
            return false;
          } else {
            ipx = 0;
            return true;
          }
          return ipx == 1 ? false : true;
        } else {
          //1.判断是不是目标节点的线
          let node = mainDiagram.selection.first();
          var status = 0; //判断目标人群节点的连线
          var status_one = 0; //判断目标人群节点的连线
          if (node instanceof $this.$go.Link) {
            let to = node.data.to;
            if (
              !mainDiagram.model.nodeDataArray.some((item) => {
                console.log(item, "251212121", item.nodeId);
                if (item.nodeId === to && item.category === "targetGroups") {
                  $this.$message.error(
                    "目标人群链接不允许单独删除！请删除节点"
                  );
                  status = 1;
                  return false;
                }
              })
            )
              return status == 1 ? false : true;
          } else if (node instanceof $this.$go.Node) {
            if (nodeOrLink.data.category === "targetGroups") {
              $this.$message.error("节点的后置节点不能删除");
              status_one = 1;
            } else {
              status_one = 0;
            }
            return status_one == 1 ? false : true;
          } else {
            return true;
          }
        }
      });
    };
    // 监听键盘事件
    mainDiagram.commandHandler.doKeyDown = function (){
      const e = mainDiagram.lastInput
      const control = e.control || e.meta
      const key = e.key
      // 自定义撤销、重做
      if(control && (key === 'Z' || key === 'Y')){
        if(key === 'Z'){
          $this.$emit("revoke");
        }else if(key == 'Y'){
          $this.$emit("redo");
        }
        return;
      }
      go.CommandHandler.prototype.doKeyDown.call(this)
    }
    mainDiagram.toolManager.dragSelectingTool.box = this.$make(
      go.Part,
      { layerName: "Tool", selectable: false },
      this.$make(go.Shape, {
        name: "SHAPE",
        fill:"rgb(240,243,255,0.4)",
        stroke: "rgb(49, 89, 255)",
        strokeWidth: 1,
        strokeDashArray: [4, 2] // 添加虚线样式
      })
    );
    //画布外整体的长和宽
    this.$data.width = window.innerWidth - 320;
    this.$data.height = window.innerHeight - (isWin ? 218 : 142);
    window.onresize = () => {
      return (() => {
        this.$data.width = window.innerWidth - 320;
        this.$data.height = window.innerHeight - (isWin ? 218 : 142);
      })();
    };

    /*****
     * 步骤3,创建模型数据(Model)*
     * myModel.nodeDataArray = [{ key: "工厂" },{ key: "车间" },{ key: "工人" },{ key: "岗位" },];
     * mainDiagram.model=myModel
     ******/
    //显示图片,在节点模板那里可以应用到
    function convertKeyImage(category) {
      // eslint-disable-next-line
      // var img = '/assets/images/icon/seniorq.png'
      return require("@/assets/imagesZhi/icon/" + category + ".svg");
    }
    //提示信息
    function diagramInfo(val) {
      console.log("545454545454");
      return val;
    }
    //千分号
    function formatNumberWithCommas(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
     }
    //执行状态,这个状态由后端返回,前边带路径
    function statusImage(val) {
      let image = "";
      switch (true) {
        case val === 1 || val === 3:
          // eslint-disable-next-line
          // image = "/images/loading.png";
          image = require("@/assets/imagesZhi/loading.png");
          break;
        case val === 2 || val === 4:
          // eslint-disable-next-line
          image = require("@/assets/imagesZhi/true.png");
          break;
        case val === 5:
          // eslint-disable-next-line
          image = require("@/assets/imagesZhi/close.png");
          break;
      }
      return image;
    }
    /*****
     * 创建节点边框的四个小点,定义一个函数来创建的点(端口)，端口在节点上的位置，通过
     * 布尔"output"和"input"的参数，控制用户是否可以从端口到端口的链接
     ******/
    let makePort = function (name, spot, output, input, portName) {
      //定义两个圆点位置
      let spotObj = new go.Spot(0, 0.5, 0, 0);
      if (name == "R") {
        spotObj = new go.Spot(1, 0.5, -3, 0);
      }
      // if(name == 'L'){
      //   spotObj = new go.Spot(0,0.5,-4,0.5)
      // }
      return $this.$make(
        go.Panel,
        "Auto",
        {
          alignment: spotObj, //元素位置设置
          width: 21,
          height: 19,
          portId: name,
          fromSpot: spotObj,
          toSpot: spotObj,
          fromLinkable: output,
          toLinkable: input,
          cursor: "crosshair",
        },
        $this.$make(go.Shape, "Circle", {
          fill: null, //设置填充
          strokeWidth: 4,
          stroke: null,
          portId: name + "portCirclr",
          width: 15,
          height: 15,
          mouseEnter:function(e, shape) {
            console.log(">>>>鼠标悬停事件>>>>")
            shape.stroke = "rgba(165,175,237,0.4)"
          },
          // 鼠标离开事件
          mouseLeave:function(e, shape) {
            console.log(">>>>鼠标离开事件>>>>")
            shape.stroke = "rgba(165,175,237,0)"
          }
        }),
        $this.$make(go.Shape, "Circle", {
          // shape1
          fill: null, //设置填充
          stroke: null,
          strokeWidth: 1,
          width: 10,
          height: 10,
          portId: name + "shape",
          mouseEnter:function(e, shape) {
            console.log(">>>>鼠标悬停事件>>>>",$this.hoverNode)
            $this.hoverNode.ports.each((port)=> {
              if(port.portId == name + "portCirclr"){
                port.stroke = true ? "rgba(165,175,237,0.4)" : null;
              }
            })
            // shape.stroke = "rgba(165,175,237,0.4)"
          },
          // 鼠标离开事件
          mouseLeave:function(e, shape) {
            console.log(">>>>鼠标离开事件>>>>",$this.hoverNode)
            $this.hoverNode.ports.each((port)=> {
              if(port.portId == name + "portCirclr"){
                port.stroke = false ? "rgba(165,175,237,0)" : null;
              }
            })
          }
        })
      );
    };
    //显示点点，边框的四个小红点
    let showSmallPorts = function (node, show) {
      node.ports.each(function (port) {
        console.log(port, "369852147");
        if (port.portId.includes("shape")) {
          port.stroke = show ? "#a5afed" : null;
          port.fill = show ? "#fff" : null;
        } else if (port.portId.includes("portCirclr")) {
          // port.strokeWidth = show ? 4 : null;
          port.stroke = show ? "rgba(165,175,237,0)" : null;
          // port.stroke = show ? "rgba(254,0,0,0.5)" : null;
        } else {
        }
      });
    };
    //Note---键盘事件
    // mainDiagram.commandHandler.doKeyDown = function () {
    //   var e = this.diagram.lastInput;
    //   var control = e.control || e.meta;
    //   var key = e.key;
    //   if (control) {
    //     console.log("按下ctrl");
    //     mainDiagram.toolManager.dragSelectingTool.isEnabled = true;
    //   }
    //   go.CommandHandler.prototype.doKeyDown.call(this);
    // };
    //Note---重写键盘弹起
    // mainDiagram.commandHandler.doKeyUp = function () {
    //   var e = this.diagram.lastInput;
    //   var control = e.control || e.meta;
    //   console.log(e);
    //   var key = e.key;
    //   if (e.key == "\u0011") {
    //     console.log("弹起ctrl");
    //     mainDiagram.toolManager.dragSelectingTool.isEnabled = false;
    //   }
    //   go.CommandHandler.prototype.doKeyUp.call(this);
    // };
    //Note----在画布里边添加contextMenu菜单
    mainDiagram.contextMenu = this.$go.GraphObject.make(
      "ContextMenu",
      // "Vertical",
      {
        background: "#red",
        width: 100,
        height: 300,
      },

      //Note-------重做操作
      //  this.$go.GraphObject.make("ContextMenuButton",
      //  this.$go.GraphObject.make(this.$go.TextBlock, "重做"),
      //   { click: function(e, obj) {
      //     e.diagram.commandHandler.redo();
      //   } },
      //   new this.$go.Binding("visible", "", function(o) {
      //    return o.diagram.commandHandler.canRedo();
      //  }).ofObject()),
      this.$go.GraphObject.make(
        "ContextMenuButton",
        this.$go.GraphObject.make(
          this.$go.TextBlock,
          "撤销"
          //  ,{
          //             alignment: go.Spot.Center,
          //             margin: 5,
          //             // font: "16px Microsoft YaHei",
          //             opacity: 0.75,
          //             font: "16px YaHei",
          //             // stroke: "#323232",
          //             // width: 100,
          //             scale: 1,
          //          }
        ),

        {
          click: function (e, obj) {
            //Note---撤销操作
            e.diagram.commandHandler.undo();
            // $this.$emit("revoke");
          },
          _buttonFillOver: "#E9F5FF",
          _buttonStrokeOver: "darkcyan",
          _buttonStrokePressed: "darkcyan",
          // _buttonFillPressed: "pink",
          "ButtonBorder.fill": "white",
          width: 100,
          height: 40,

          // _buttonFillPressed: "red",
          visible: true,
        },
        new this.$go.Binding("visible", "", function (o) {
          return o.diagram.commandHandler.canUndo();
        }).ofObject()
      ),
      //Note-------另存为操作
      this.$go.GraphObject.make(
        "ContextMenuButton",
        this.$go.GraphObject.make(
          this.$go.TextBlock,
          // ,{
          //               alignment: go.Spot.Center,
          //               margin: 5,
          //               font: "16px YaHei",
          //               opacity: 0.75,
          //               // stroke: "#323232",
          //               scale: 1,
          //    },
          "另存为模板"
        ),
        {
          click: function (e, obj) {
            $this.$emit("saveAs");
          },
          _buttonFillOver: "#E9F5FF",
          _buttonStrokeOver: "darkcyan",
          _buttonStrokePressed: "darkcyan",
          // _buttonFillPressed: "pink",
          "ButtonBorder.fill": "white",
          width: 100,
          height: 40,

          // _buttonFillPressed: "red",
          visible: true,
        }
      )
    );
    //鼠标点击，选中状态
    mainDiagram.nodeSelectionAdornmentTemplate = this.$make(
      this.$go.Adornment,
      "Auto",
      this.$make(this.$go.Shape, {
        fill: null,
        stroke: "deepskyblue",
        strokeWidth: 1.5,
        strokeDashArray: [4, 2],
      }),
      this.$make(this.$go.Placeholder)
    );
    //节点模板
    mainDiagram.nodeTemplate = this.$make(
      this.$go.Node,
      "Auto",
      //设置节点宽度1.0 padding: new go.Margin(0, 0, 8, 8) 
      // { minSize: new go.Size(100, 100), maxSize: new go.Size(100, 100) },
      { minSize: new go.Size(NaN, NaN), maxSize: new go.Size(NaN, NaN) },
      //Note----右键菜单
      { resizable: true },
      //更改鼠标移入效果，改为十字标样式
      { cursor: "move"},
      //升级---鼠标移入事件
      {
        selectionAdornmentTemplate: this.$make(
          this.$go.Adornment,
          "Auto",
          this.$make(
            this.$go.Shape,
            {
              fill:null ,
              strokeWidth: 0.5, //智能营销1.0添加边框
              strokeDashArray: [4, 2],
              figure:"RoundedRectangle"
              //  height:90
            },
            new this.$go.Binding("stroke", "isSaveContent", (val) => {
              return val ? "rgba(49, 89, 255, 1)" : "red";   //智能营销优化1.0
            })
          ),
          this.$make(this.$go.Placeholder)
        ),
      },
      {
        locationSpot: this.$go.Spot.Center,
        locationObjectName: "SHAPE",
        layerName: "Background",
        fromSpot: this.$go.Spot.Right,
        toSpot: this.$go.Spot.Left,
        doubleClick: function (e, node) {
          //节点双击事件
          $this.$emit("object-double-clicked", node);
        },
      },
      {
        toolTip: this.$make(
          this.$go.Adornment,
          "Spot",
          // { background: "transparent" },
          this.$make(this.$go.Placeholder, { padding: 0 }),
          this.$make(
            this.$go.TextBlock,
            {
              alignment: go.Spot.Top,
              alignmentFocus: go.Spot.Bottom,
              cursor: "pointer",
              stroke: "red",
            },
            new go.Binding("text", "errorDesc", diagramInfo)
          ),
          //鼠标移入显示文字样式
          this.$make(this.$go.Panel,"Spot", {  
             alignment: go.Spot.Bottom,
             alignmentFocus: go.Spot.Top
           },    
             this.$make(this.$go.Panel,"Auto",  
              this.$make(this.$go.Shape, "RoundedRectangle", {
                 strokeWidth: 0,
                 fill: "#fff" //悬浮框背景色
               }
              ),
              this.$make(this.$go.TextBlock, { //控制文字显示
                stroke: "#333", //悬浮框字体颜色
                margin: 8,
                font: '12px InterVariable',
                // textAlign: "center",
                editable: true,
                wrap: go.TextBlock.WrapDesiredSize, // 设置文本块自动换行
                maxSize: new go.Size(150, Infinity) // 设置最大宽度为200，高度不限
               }, new go.Binding("text", "name").makeTwoWay())
            ),
            this.$make(this.$go.Shape, "Triangle", {
              alignment: new go.Spot(0.5, 0),
              width: 15,
              height: 15,
              strokeWidth: 0,
              fill: "#fff" //悬浮框三角形颜色
           })
          ),
          // this.$make(this.$go.TextBlock, "Bottom",
          // { alignment: go.Spot.Bottom, alignmentFocus: go.Spot.Top, stroke: "red" },
          // new go.Binding("text", "color", function(s) { return "color: " + s; }))
        ),
        // contextMenu: partContextMenu
      },
      //绑定在location，才不会添加节点的时候，图标自动到左上角去
      new this.$go.Binding(
        "location",
        "coordinate",
        this.$go.Point.parse
      ).makeTwoWay(this.$go.Point.stringify),
      // 链接
      this.$make(this.$go.Shape, {
        fill: "transparent",
        stroke: null,
        // fromLinkable: true,
        // toLinkable: true,
        // portId: "linkShape",
        cursor: "pointer",
        strokeWidth: 1.5,
        strokeDashArray: [4, 2],
        name: "Shape"  //智能营销优化1.0
      }),
      //Note-----右键菜单
      {
        contextMenu:this.$make(this.$go.HTMLInfo, {
          show: this.showContextMenu,
          hide: this.hideContextMenu
        })
      },
      // {
      //   contextMenu: this.$go.GraphObject.make(
      //     "ContextMenu",
      //     "Vertical",
      //     {
      //       background: "rgba(0,0,0,0.7)",
      //       width: 140,
      //       shadowVisible: true, // 显示阴影
      //       shadowColor: "transparent", // 阴影颜色
      //     },
      //     this.$go.GraphObject.make(
      //       "ContextMenuButton",
      //       {
      //         "ButtonBorder.fill": "#000000",
      //         _buttonFillOver: "#000000",
      //         // _buttonFillPressed: "red",
      //         shadowVisible: false, // 显示阴影
      //         visible: true,
      //       },
      //       this.$go.GraphObject.make(this.$go.TextBlock, {
      //         text: "操作",
      //         stroke: "#ffffff",
      //         font: "15px sans-serif",
      //         margin: new this.$go.Margin(10, 0, 10, 0),
      //       })
      //     ),
      //     this.$go.GraphObject.make(
      //       "ContextMenuButton",
      //       {
      //         "ButtonBorder.fill": "rgba(0,0,0,0.7)",
      //         _buttonFillOver: "rgba(0,0,0,0.9)",
      //         margin: new this.$go.Margin(0, 0, 0, 0),
      //       },
      //       this.$go.GraphObject.make(this.$go.TextBlock, {
      //         text: "删除",
      //         stroke: "#ffffff",
      //         font: "14px sans-serif",
      //         margin: new this.$go.Margin(10, 0, 10, 0),
      //         height: 18,
      //       }),
      //       {
      //         cursor: "pointer",
      //         click: (e, obj) => {
      //           //Note----右键删除
      //           $this.$emit("object-delete1");
      //           // $this.$emit("delectTrue",obj.part.data.nodeDataArray);
      //           // console.log(
      //           //   e,
      //           //   "5555555",
      //           //   e.diagram.selection,
      //           //   obj.part.data.smartMarketingNodeId,
      //           //   JSON.stringify(obj.part.data)
      //           // );
      //           // alert(JSON.parse(JSON.stringify(obj.part.data)), "566666");
      //           // alert(obj.part.data.key + ":1");
      //         },
      //       }
      //     ),
      //     this.$go.GraphObject.make(
      //       "ContextMenuButton",
      //       {
      //         "ButtonBorder.fill": "rgba(0,0,0,0.7)",
      //         _buttonFillOver: "rgba(0,0,0,0.9)",
      //         margin: new this.$go.Margin(0, 0, 0, 0),
      //       },
      //       new this.$go.Binding("visible", "visible"),
      //       this.$go.GraphObject.make(this.$go.TextBlock, {
      //         text: "复制",
      //         stroke: "#ffffff",
      //         font: "14px sans-serif",
      //         margin: new this.$go.Margin(10, 0, 10, 0),
      //         height: 18,
      //       }),
      //       {
      //         cursor: "pointer",
      //         click: (e, obj) => {
      //           $this.$emit("copy-change");
      //         },
      //       }
      //     ),
      //     // 短信预览
      //     this.$go.GraphObject.make(
      //       "ContextMenuButton",
      //       {
      //         "ButtonBorder.fill": "rgba(0,0,0,0.7)",
      //         _buttonFillOver: "rgba(0,0,0,0.9)",
      //         visible: true,
      //       },
      //       this.$go.GraphObject.make(this.$go.TextBlock, {
      //         text: "预览短信",
      //         stroke: "#ffffff",
      //         font: "14px sans-serif",
      //         margin: new this.$go.Margin(10, 0, 10, 0),
      //       }),
      //       {
      //         cursor: "pointer",
      //         click: function (e, obj) {
      //           //Note---预览操作
      //           // e.diagram.commandHandler.undo();
      //           $this.$emit("open-msg");
      //         },
      //       },
      //       new this.$go.Binding("visible", "", function (o) {
      //         // console.log('canUndo',o.diagram.commandHandler.canUndo);

      //         return $this.showMenu(99);
      //       }).ofObject()
      //     ),
      //     // 插入后置：
      //     this.$go.GraphObject.make(
      //       "ContextMenuButton",
      //       {
      //         shadowVisible: false, // 显示阴影
      //         "ButtonBorder.fill": "#000000",
      //         _buttonFillOver: "#000000",
      //         // _buttonFillPressed: "red",
      //         visible: true,
      //       },
      //       this.$go.GraphObject.make(this.$go.TextBlock, {
      //         text: "插入后置节点",
      //         stroke: "#ffffff",
      //         font: "15px sans-serif",
      //         margin: new this.$go.Margin(10, 0, 10, 0),
      //       }),
      //       new this.$go.Binding("visible", "", function (o) {
      //         return $this.showMenu("all");
      //       }).ofObject()
      //     ),

      //     ...this.afterNodeList.map((item) => {
      //       return this.$go.GraphObject.make(
      //         "ContextMenuButton",
      //         {
      //           shadowVisible: false, // 显示阴影
      //           "ButtonBorder.fill": "rgba(0,0,0,0.7)",
      //           _buttonFillOver: "rgba(0,0,0,0.9)",
      //           margin: new this.$go.Margin(0, 0, 0, 0),
      //           visible: true,
      //         },
      //         this.$go.GraphObject.make(this.$go.TextBlock, {
      //           text: item.name,
      //           stroke: "#ffffff",
      //           font: "14px sans-serif",
      //           margin: new this.$go.Margin(10, 0, 10, 0),
      //           height: 18,
      //         }),
      //         {
      //           cursor: "pointer",
      //           click: function (e, obj) {
      //             //Note---预览操作
      //             // e.diagram.commandHandler.undo();
      //             $this.$emit(`afterNodeClick`, {
      //               type: item.index,
      //               name: item.name,
      //             });
      //           },
      //         },
      //         new this.$go.Binding("visible", "", function (o) {
      //           return $this.showMenu(item.index);
      //         }).ofObject()
      //       );
      //     }),
      //     this.$go.GraphObject.make(
      //       "ContextMenuButton",
      //       {
      //         shadowVisible: false, // 显示阴影
      //         "ButtonBorder.fill": "rgba(0,0,0,0.7)",
      //         _buttonFillOver: "rgba(0,0,0,0.9)",
      //         margin: new this.$go.Margin(0, 0, 0, 0),
      //         visible: true,
      //       },
      //       this.$go.GraphObject.make(this.$go.TextBlock, {
      //         text: "人群分析",
      //         stroke: "#ffffff",
      //         font: "14px sans-serif",
      //         margin: new this.$go.Margin(10, 0, 10, 0),
      //       }),
      //       {
      //         cursor: "pointer",
      //         click: function (e, obj) {
      //           //Note---预览操作
      //           // e.diagram.commandHandler.undo();
      //           $this.$emit(`afterNodeClick`, { type: 14, name: "人群分析" });
      //         },
      //       },
      //       new this.$go.Binding("visible", "", function (o) {
      //         return $this.showMenu(14);
      //       }).ofObject()
      //     )
      //     // this.$go.GraphObject.make(
      //     //   "ContextMenuButton",
      //     //   {
      //     //     "ButtonBorder.fill": "white",
      //     //     "ButtonBorder.stroke": "darkcyan",
      //     //     "ButtonBorder.strokeWidth": 3,
      //     //     _buttonFillOver: "#E9F5FF",
      //     //     _buttonStrokeOver: "darkcyan",
      //     //     _buttonStrokePressed: "darkcyan",
      //     //     _buttonFillPressed: "pink",
      //     //     visible: true,
      //     //     margin: new this.$go.Margin(10, 0, 10, 0),
      //     //   },
      //     //   this.$go.GraphObject.make(this.$go.TextBlock, {
      //     //     text: "Alert3",
      //     //     margin: new this.$go.Margin(10, 0, 10, 0),
      //     //   }),
      //     //   {
      //     //     cursor: "pointer",
      //     //     click: (e, obj) => {
      //     //       console.log(obj);
      //     //       alert(obj.part.data.key + ":3");
      //     //     },
      //     //   }
      //     // )
      //   ),
      // },
      // four small named ports, one on each side:
      // makePort("T", go.Spot.Top, false, true),
      // makePort("L", go.Spot.Left, true, true),
      // makePort("R", go.Spot.Right, true, true),
      // makePort("B", go.Spot.Bottom, true, false),
      {
        // handle mouse enter/leave events to show/hide the ports
        mouseEnter: function (e, node) {
          $this.hoverNode = node
          $this.$emit("mouseEventChange", e, node); //升级---鼠标移入事件
          showSmallPorts(node, true);
          // 获取节点的形状并添加边框1.0
          const shape = node.findObject("Shape");
          if (shape) {
            // shape.stroke = "rgba(0, 191, 255, 0.3)"; //设置边框
            shape.strokeWidth = 1;
            shape.fill = "rgba(231, 235, 255, 1)"; // 设置透明背景色

            shape.figure="RoundedRectangle"
           }
        },
        mouseLeave: function (e, node) {
          $this.hoverNode = node
          showSmallPorts(node, false);
          const shape = node.findObject("Shape");
          console.log(shape,'6932587741');
          if (shape) {
            shape.stroke = null;
            shape.strokeWidth = null;
            shape.fill = null; // 设置透明背景色
          }
        },
      },
      // 面板
      this.$make(
        this.$go.Panel,
        "Vertical",
        // 节点更新文字
        this.$make(
          this.$go.TextBlock,
          {
            font: "12px 微软雅黑",
            margin: 4,
            maxSize: new this.$go.Size(80, NaN),
            wrap: this.$go.TextBlock.WrapFit,
            stroke: "#627085",
          },
          new this.$go.Binding("text", 'resultCount')
          // .makeTwoWay(function(value) {  //转为千分号
          //   console.log(value,'qweqwe ');
            
          //      return formatNumberWithCommas(value);
          // })
        ),
        //Note---连线靠近坐标处理
        this.$make(
          this.$go.Panel,
          "Auto",
          this.$make(
            this.$go.Panel,
            this.$go.Panel.Position,
            // 状态图标
            this.$make(
              this.$go.Picture,
              {
                desiredSize: new this.$go.Size(12, 12),
                position: new this.$go.Point(49, 0),
              },
              new this.$go.Binding("source", "executionStatus", statusImage)
            ),
            // 主图像
            this.$make(
              this.$go.Picture,
              {
                desiredSize: new this.$go.Size(45, 45),
                position: new this.$go.Point(6, 0),
                portId: "linkShape",
        
                // fromLinkable: true,
                // toLinkable: true,
              },
              new this.$go.Binding("source", "category", convertKeyImage)
            )
          ),
          makePort("L", this.$go.Spot.Left, true, true),
          makePort("R", this.$go.Spot.Right, true, true)
        ),
        // 名称文字
        this.$make(
          this.$go.TextBlock,
          {
            // 旧
            // font: "12px 微软雅黑",
            // margin: 8,
            // maxSize: new this.$go.Size(95,15), //修改文字名称1.0
            // wrap: this.$go.TextBlock.WrapFit,
            // overflow: this.$go.TextBlock.OverflowEllipsis, //文案超出截取
            // // 设置文本的垂直和水平对齐方式
            // alignment: this.$go.Spot.Center,

            //新
            font: "12px 微软雅黑",
            margin: 8,
            maxSize: new this.$go.Size(95, NaN), // 高度自适应，不限制
            wrap: this.$go.TextBlock.WrapFit, // 自动换行
            overflow: this.$go.TextBlock.OverflowClip, // 超出部分隐藏，不截取
            alignment: this.$go.Spot.Center, // 居中对齐
          },
          new this.$go.Binding("stroke", "isSaveContent", (val) => {
            console.log(val);
            return val ? "#627085" : "red";
          }),
          new this.$go.Binding("text")
        ),
        //鼠标移入显示完整名称
        this.$make(go.TextBlock, {
           textAlign: "center",
           font: "bold 10pt helvetica, arial, sans-serif",
           stroke: "#333",
           margin: 4,
           isMultiline: true, // 允许多行文本
           maxSize: new go.Size(100, NaN), // 设置最大宽度为100，高度不限
           overflow: go.TextBlock.OverflowClip, // 超出部分隐藏
           visible: false // 初始状态下不可见
         },
         new go.Binding("text", "name"),
         new go.Binding("visible", "isMouseOver", (val) => val)) // 根据鼠标是否悬停来控制可见性
      )
    );
    //链接模板
    mainDiagram.linkTemplate = this.$make(
      this.$go.Link,
      {
        // routing: this.$go.Link.AvoidsNodes, //链接线避开节点
        routing: this.$go.Link.Orthogonal, //Note修改路由规则，否则线会出现问题
        corner: 100, //直角弧度
        curve: this.$go.Link.JumpOver,
        reshapable: true, // 允许线形修改
        // 鼠标移到连线上后高亮，自己加的效果
        // mouseEnter: function(e, link) { link.findObject("HIGHLIGHT").stroke = "rgba( 52, 52, 52,0.1)"; },
        // mouseLeave: function(e, link) { link.findObject("HIGHLIGHT").stroke = "transparent"; },
        // selectionAdorned: false
      },
      //  this.$make(this.$go.Shape,  // 隐藏的连线形状，8个像素粗细，当鼠标移上后显示
      //  { isPanelMain: true, strokeWidth: 6, stroke: "transparent", name: "HIGHLIGHT" }),
      this.$make(
        this.$go.Shape,
        { isPanelMain: true, stroke: "#A5AFED", strokeWidth: 1 },
        new this.$go.Binding("stroke", "isSelected", function (sel) {
          return sel ? "dodgerblue" : "#A5AFED";
        }).ofObject()
      ),
      this.$make(this.$go.Shape, {
        toArrow: "standard",
        strokeWidth: 1,
        stroke: "#A5AFED",
        fill: "#A5AFED",
        scale:0.8//线箭头大小设置
      }),
      this.$make(this.$go.Panel,{segmentIndex: 1, segmentFraction: 0.2},this.$make(this.$go.Shape,{
        strokeWidth: 1,
        stroke: "#ffffff",
        fill: "#ffffff",
        figure:"RoundedRectangle",
        width: 20,
        height: 20,
        visible: true
      }),
      this.$make(
        this.$go.TextBlock,
        {
          font: "14px 微软雅黑",
          maxSize: new this.$go.Size(90, NaN),
          wrap: this.$go.TextBlock.WrapFit,
          textAlign:'center',
          stroke: "#A5AFED",
          margin:new this.$go.Margin(4,0,0,6)
        },
        new this.$go.Binding("text")
      ),
      new this.$go.Binding("visible",function(i){
        return i.text && i.connectionType == 'input'?true:false
        })
      ),
      this.$make(this.$go.Panel,{segmentIndex: 3, segmentFraction: 0.8},this.$make(this.$go.Shape,{
        strokeWidth: 1,
        stroke: "#ffffff",
        fill: "#ffffff",
        figure:"RoundedRectangle",
        width: 20,
        height: 20,
        visible: true,
      }),
      this.$make(
        this.$go.TextBlock,
        {
          font: "14px 微软雅黑",
          maxSize: new this.$go.Size(90, NaN),
          wrap: this.$go.TextBlock.WrapFit,
          textAlign:'center',
          stroke: "#A5AFED",
          margin:new this.$go.Margin(4,0,0,6)
        },
        new this.$go.Binding("text")
      ),
      new this.$go.Binding("visible",function(i){
        return i.text && i.connectionType == 'output'?true:false
        })
      )
    );
    // Note------上一步和下一步操作
    mainDiagram.addModelChangedListener((ent) => {
      // Note-----判断他是不是撤回操作
      if (ent.propertyName == "FinishedUndo") {
        $this.$emit("revoke");
        console.log(ent.model.linkDataArray, "66666666");
        console.log(ent.model.nodeDataArray, "8888888");
      } else if (ent.propertyName == "FinishedRedo") {
        $this.$emit("redo");
      }
    });
    /*****
     * 步骤4,数据获取显示*
     ******/
    this.diagram = mainDiagram;
    this.diagram.model.linkFromPortIdProperty = "fromPort";
    this.diagram.model.linkToPortIdProperty = "toPort";
    //预览小图
    this.overview = this.$make(this.$go.Overview, this.$refs.overview, {
      observed: mainDiagram,
      contentAlignment: this.$go.Spot.Center,
    });

    this.overview = this.$make(this.$go.Overview, this.$refs.overview1, {
      observed: mainDiagram,
      contentAlignment: this.$go.Spot.Center,
    });

    // 更新数据
    this.updateModel(this.modelData);
  },
  watch: {
    modelData: function (val) {
      console.log("modelData:", val);
      val.linkFromPortIdProperty = "fromPort";
      val.linkToPortIdProperty = "toPort";
      this.diagram && this.updateModel(val);
    },
    isReadOnly: function (val) {
      this.diagram.isReadOnly = val;
    },
  },
  methods: {
    //放大缩小
    zoom() {
      this.telescoping = Math.floor((this.telescoping + 0.1) * 100) / 100;
      this.diagram.scale = this.telescoping * 0.1 + 0.1;
    },
    //缩小
    zoomOut() {
      this.telescoping = Math.floor((this.telescoping - 0.1) * 100) / 100;
      this.diagram.scale = this.telescoping * 0.1 - 0.1;
    },
    //恢复默认
    defaultChange() {
      this.telescoping = 10;
      this.diagram.scale = 1;
    },
    //放大缩小
    sliderChange(val) {
      this.telescoping = val;
      this.diagram.scale = val * 0.1;
    },
    //缩略图事件
    expandShrink() {
      this.isOverview1 = !this.isOverview1;
    },
    model() {
      return this.diagram.model;
    },
    getDiagram() {
      return this.diagram;
    },
    updateModel(val) {
      let x = Number(sessionStorage.getItem("x"));
      let y = Number(sessionStorage.getItem("y"));
      //Note----不让图标居中
      this.diagram.initialPosition = new this.$go.Point(x, y);
      if (val instanceof this.$go.Model) {
        val.linkFromPortIdProperty = "fromPort";
        val.linkToPortIdProperty = "toPort";
        this.diagram.model = val;
        this.diagram.model.linkFromPortIdProperty = "fromPort";
        this.diagram.model.linkToPortIdProperty = "toPort";
      } else {
        var m = new this.$go.GraphLinksModel();
        if (val) {
          for (var p in val) {
            m[p] = val[p];
          }
        }
        m.linkFromPortIdProperty = "fromPort";
        m.linkToPortIdProperty = "toPort";
        this.diagram.model = m;
        this.diagram.model.linkFromPortIdProperty = "fromPort";
        this.diagram.model.linkToPortIdProperty = "toPort";
      }
    },
    updateDiagramFromData() {
      //刷新用到
      this.diagram.startTransaction();
      this.diagram.updateAllRelationshipsFromData();
      this.diagram.updateAllTargetBindings();
      this.diagram.commitTransaction("updated");
    },
    showMenu(type) {
      let list = this.diagram.selection;
      let nodeNumListBatch = [];
      list.each((nodeOrLink, index) => {
        if (nodeOrLink.data.category) {
          nodeNumListBatch.push(nodeOrLink.data);
        }
      });
      // console.log("nodeNumListBatch",nodeNumListBatch)
      // 等待节点也显示后置插入节点
      // const isAwait = nodeNumListBatch.every(item=>item.category == 'await')
      // if(nodeNumListBatch.find(item => !(item.isSaveContent)) && !isAwait){
      //   return false;
      // }
      if (nodeNumListBatch.length == 1) {
        let node = afterListObj[nodeNumListBatch[0].type];
        if (!node) {
          return false;
        } else if (type == "all") {
          return true;
        }
        let flag = node.includes(type);
        return Boolean(flag);
      } else {
        let after = this.findDuplicates(nodeNumListBatch);
        if (after.length == 0) {
          return false;
        } else if (type == "all") {
          return true;
        }
        let flag = after.includes(type.toString());
        return Boolean(flag);
      }
    },
    findDuplicates(nodeList) {
      let arr = [];
      nodeList.forEach((item) => {
        let after = afterListObjBatch[item.type] || [];
        arr = [...arr, ...after];
      });

      // 使用reduce方法创建一个新的包含唯一值的对象
      const uniqueMap = arr.reduce((acc, curr) => {
        acc[curr] = (acc[curr] || 0) + 1;
        return acc;
      }, {});
      // 找出出现次数大于1的元素

      return Object.keys(uniqueMap).filter(
        (key) => uniqueMap[key] == nodeList.length
      );
    },
    // 全屏
    toggleFull(){
      this.$emit('toggleFull')
    },
    showContextMenu(obj, diagram, tool) {
      var hasMenuItem = false;
      function maybeShowItem(elt, pred) {
        if (pred) {
          elt.style.display = "block";
          hasMenuItem = true;
        } else {
          elt.style.display = "none";
        }
      }
      let list = this.diagram.selection
      let nodeNumListBatch = [];
      list.each((nodeOrLink, index) => {
        if(nodeOrLink.data.category){
          nodeNumListBatch.push(nodeOrLink.data);
        }
      });
      let isShow = true
      nodeNumListBatch.forEach(item =>{
        if(item.type == 9){
          isShow = false
        }
      })
      maybeShowItem(this.$refs.deleteRef, true);
      maybeShowItem(this.$refs.copyRef, true);
      maybeShowItem(this.$refs.previewRef, this.showMenu(99));
      maybeShowItem(this.$refs.afterRef, this.showMenu('all'));
      if(isShow){
        maybeShowItem(this.$refs.deleteRef, true);
        maybeShowItem(this.$refs.copyRef, true);
        maybeShowItem(this.$refs.disabledDeleteRef, false);
        maybeShowItem(this.$refs.disabledCopyRef, false);
      }else{
        this.$refs.lineRef.style.display = 'none'
        maybeShowItem(this.$refs.deleteRef, false);
        maybeShowItem(this.$refs.copyRef, false);
        maybeShowItem(this.$refs.disabledDeleteRef, true);
        maybeShowItem(this.$refs.disabledCopyRef, true);
      }
      if(!this.showMenu('all')){
        this.$refs.lineRef.style.display = 'none'
      }else{
        this.$refs.lineRef.style.display = 'block'
      }
      if (hasMenuItem) {
        this.showContextMenuVisible = true
        var mousePt = diagram.lastInput.viewPoint;
        const cxElement = this.$refs.contextMenu
        cxElement.style.left = mousePt.x + 5 + "px";
        cxElement.style.top = mousePt.y + "px";
      }
      window.addEventListener("click", this.hideCX, true);
    },
    hideContextMenu() {
      this.showContextMenuVisible = false
      window.removeEventListener("click", this.hideCX, true);
    },
    hideCX() {
      if (this.diagram.currentTool instanceof this.$go.ContextMenuTool) {
        this.diagram.currentTool.doCancel();
      }
    },
    contextMenuPopoverShow(){
      this.afterNodeList.forEach(item=>{
        if(this.showMenu(item.index)){
          this.$refs[`${item.icon}Ref`][0].style.display = "block"
        }else{
          this.$refs[`${item.icon}Ref`][0].style.display = "none";
        }
      })
    },
    contextMenuClick(type,item){
      if(type == 'delete'){
        this.$emit("object-delete1")
      }else if(type == 'copy'){
        this.$emit("copy-change")
      }else if(type == 'preview'){
        this.$emit("open-msg")
      }else if(type == 'afterNodeClick'){
        this.$emit(`afterNodeClick`,{type:item.index,name:item.name})
        const popoverDom = document.getElementsByClassName('diagram-contextMenu-popover')
        if(popoverDom){
          popoverDom[0].style.display = "none"
        }
      }
    }
  },
  computed: {
    afterNodeList() {
      let arr = this.icons.reduce((arr, item, index) => {
        return index ? [...arr, ...item.chliden] : arr;
      }, []);
      console.log("arr", arr);
      return arr;
    },
  },
};
</script>

<style lang="less">
.diagram {
  position: relative;
  height: 90%;
  .overview {
    position: absolute;
    width: 240px;
    height: 160px;
    bottom: 35px;
    right: 12px;
    background-color: #d7e1f9;
    z-index: 300; /* make sure its in front */
    box-shadow: 0px 6px 20px rgba(0,0,0,0.1) !important;  /* 新增投影效果 */
  }
  .scroll{
    & > div{
      &::-webkit-scrollbar-thumb{
        background: #EFEFEF;
      }
      &::-webkit-scrollbar-track{
        background: #ffffff;
      }
    }
  }
}
.overview1 {
  position: absolute;
  width: 240px;
  height: 23px;
  bottom: 12px;
  right: 12px;
  background-color: #fff;
  z-index: 300; /* make sure its in front */
  border-radius: 0px 0px 4px 4px;
  padding: 5px 10px;
  font-size: 12px;
  color: #989693;
  display: flex;
  align-items: center;
}
.line{
  margin: 0px 10px;
  margin-top: 2px;
  height: 15px;
}
.slider{
  flex:1;
}
.refresh {
  position: absolute;
  top: 5px;
  right: 58px;
  color: black;
}
.reductionIcon {
  margin-left: 10px;
  margin-right: 10px;
  cursor: pointer;
}
.toggleFulls {
  cursor: pointer;
}
.operate-icon{
  width: 14px;
  height: 14px;
}
.contextMenu{
  position: absolute;
  z-index: 999;
  width: 180px;
  padding: 12px;
  background-color: #fff;
  color: #333;
  box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.15);
  border-radius: 2px;
  &-item{
    display: block;
    height: 30px;
    font-size: 12px;
    line-height: 30px;
    padding-left: 4px;
    cursor: pointer;
    &:hover{
      background-color: #F2F4F9;
      border-radius: 2px;
    }
    &-img{
      width: 18px;
      height: 18px;
    }
  }
  &-after{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 4px;
  }
  &-line{
    border-bottom: 1px solid #EEEEEE;
    margin: 9px 0px;
  }
  &-afterItem{
    padding: 0px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.diagram-contextMenu-popover{
  margin-left: 22px!important;
  border-radius: 2px;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.15);
  .popper__arrow{
    display: none;
  }
}
.contextMenu-item-disabled{
  color: #999999 !important;
  cursor: no-drop !important;
}
</style>
